<table mat-table [dataSource]="dataSource" style="z-index: 0;" matSort (matSortChange)="onSortChange($event)">
  @if (select) {
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? toggleAllRows() : null" color="primary"
                      [checked]="hasPageSelection() && isAllSelected()" [indeterminate]="hasPageSelection() && !isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" color="primary" (change)="$event ? toggle(row) : null"
                      [checked]="isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>
  }
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span class=" small light bold">
        {{'TRADEMARK.REPRODUCTION_STANDARD_CHARACTERS_SHORT' | translate}}
      </span>
    </th>
    <td mat-cell *matCellDef="let trademark">
      <div [class.clickable]="button !== undefined" (click)="button !== undefined ? toTrademark(trademark) : null">
        <span class="main bold" *ngIf="trademark.name">{{trademark.name}}</span>
        <span class="text light" *ngIf="!trademark.name && !['Figurative','Colour'].includes(trademark.type)">-</span>
        <span class="small light" *ngIf="!trademark.name && trademark.type === 'Figurative'">({{'TRADEMARK.FIGURATIVE' |
          translate}})</span>
        <span class="small light" *ngIf="!trademark.name && trademark.type === 'Colour'">({{'TRADEMARK.COLOUR' |
          translate}})</span>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="identifier">
    <th mat-header-cell *matHeaderCellDef>
      <span class=" small light bold">
        {{'TRADEMARK.IDENTIFIER_NUMBER_SHORT' | translate}}
      </span>
    </th>
    <td mat-cell *matCellDef="let trademark">
      <div class="fx-column">
        <span class="text">{{trademark.identifierNumber}}</span>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="countryOfDesignation">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span class=" small light bold">
        {{'ENTITIES.TERRITORY' | translate}}
      </span>
    </th>
    <td mat-cell *matCellDef="let trademark">
      <app-trademark-country displayMode="full" [wipoCode]="trademark.countryOfDesignation"></app-trademark-country>
    </td>
  </ng-container>
  <ng-container matColumnDef="niceClassification">
    <th mat-header-cell *matHeaderCellDef>
      <span class=" small light bold">
        {{'TRADEMARK.NICE_CLASSIFICATION_SHORT' | translate}}
      </span>
    </th>
    <td mat-cell *matCellDef="let trademark">
      <div class="fx-row fx-wrap align-items-center justify-content-start">
        <app-trademark-nice-classification
          [niceClassification]="trademark.niceClassification"></app-trademark-nice-classification>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>
      <span class="small light bold">
        {{'TRADEMARK.STATUS' | translate}}
      </span>
    </th>
    <td mat-cell *matCellDef="let trademark">
      <div class="fx-row align-items-center justify-content-start">
        <app-trademark-status [status]="trademark.status" *ngIf="trademark.status"></app-trademark-status>
      </div>
      <span class="text light" *ngIf="!trademark.status">-</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="representation">
    <th mat-header-cell *matHeaderCellDef>
      <span class=" small light bold">
        {{'TRADEMARK.REPRODUCTION_SHORT' | translate}}
      </span>
    </th>
    <td mat-cell *matCellDef="let trademark">
      <img [src]="trademark.reproductionURI" class="trademark-representation" *ngIf="trademark.reproductionURI" />
      <span class="text light" *ngIf="!trademark.reproductionURI">-</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="synchronization">
    <th mat-header-cell *matHeaderCellDef>
      <span class="small light bold">
        {{'SYNC.LAST_SYNCHRONIZATION' | translate}}
      </span>
    </th>
    <td mat-cell *matCellDef="let trademark">
      <div class="fx-row align-items-center justify-content-start" [matTooltipClass]="{'uzai-tooltip':true}"
        [matTooltip]="synchronizationTooltip(trademark)">
        @if (trademark.synchronization) {
          <mat-icon class="mr-5" [class.green]="isSynchronizationSuccess(trademark)"
            [class.orange]="!isSynchronizationSuccess(trademark)" fontSet="material-icons-outlined">{{
            isSynchronizationSuccess(trademark) ? 'check_circle' : 'error' }}</mat-icon>
          <span class="text">{{formatSynchronizationDate(trademark.synchronization.date)}}</span>
        } @else {
          <span class="text light">-</span>
        }
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>
      <button mat-icon-button [cdkMenuTriggerFor]="columnsMenu" [matTooltipClass]="{'uzai-tooltip':true}"
        [matTooltip]="'TRADEMARKS_LIST.DISPLAYED_COLUMNS' | translate">
        <mat-icon class="light" fontSet="material-icons-outlined">view_column</mat-icon>
      </button>
      <ng-template #columnsMenu>
        <mat-card class="menu-container p-0 elevation" cdkMenu>
          <div class="fx-column" (click)="$event.stopPropagation()">
            <div class="p-16">
              <span class="text bold">{{'TRADEMARKS_LIST.DISPLAYED_COLUMNS' | translate}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="fx-column pv-8">
              <div class="fx-row align-items-center justify-content-start menu-item actionable clickable"
                (click)="toggleSynchronization()">
                <mat-checkbox color="primary" [checked]="showSynchronization"></mat-checkbox>
                <span class="text ml-5">{{'SYNC.LAST_SYNCHRONIZATION' | translate}}</span>
              </div>
            </div>
          </div>
        </mat-card>
      </ng-template>
    </th>
    <td mat-cell *matCellDef="let trademark">
      <mat-icon [class]="button?.class || 'main'" fontSet="material-icons-outlined"
        [class.clickable]="button !== undefined" (click)="action(trademark)">{{button?.icon ||
        'keyboard_arrow_right'}}</mat-icon>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
  <tr mat-row *matRowDef="let trademark; columns: visibleColumns;" [class.clickable]="button === undefined"
    (click)="button === undefined ? action(trademark) : null">
  </tr>
</table>
<div class="p-16" *ngIf="done && !loading && trademarks.totalDocs === 0">
  <span class="text light">{{'TRADEMARKS_LIST.SEARCH_NO_TRADEMARKS' | translate}}</span>
</div>
<mat-paginator [length]="trademarks.totalDocs || 0" [pageSize]="trademarks.limit || 0"
  [pageIndex]="trademarks && trademarks.page ? (trademarks.page-1) : 0" [pageSizeOptions]="[10, 25, 50, 100]"
  (page)="handlePage($event)">
</mat-paginator>
